module.exports = __webpack_public_path__ + "img/btn-1.4a8f64f6.png";